export default __webpack_public_path__ + "static/media/Group84191.58d39014.svg";